/** @jsxImportSource theme-ui */
import { Box, Text, merge, Button as ThemeUiButton } from "theme-ui";

import { SvgOrImg } from "components";
import { useTiltEffect } from "hooks";
import * as styles from "./ProductButton.styles";

export default function ProductButton({
  logo,
  description,
  productLogo,
  subText,
  textColor,
  boxColor,
  borderTop,
  selectLabelHeight,
  selectLabelFontSizeDesktop,
  selectLabelFontSizeMobile,
  bauerLogo,
  selectLabel = "SELECT",
  color,
  backgroundColor,
  backgroundImage,
  isSelected = false,
  onClick,
  ...props
}) {
  const { ref, wrapperStyles } = useTiltEffect({ disable: isSelected });

  return (
    <Box
      sx={merge(wrapperStyles, {
        display: "flex",
        flexDirection: "row",
        textDecoration: "none",
      })}
    >
      <ThemeUiButton
        aria-label={logo.alt}
        variant="unstyled"
        data-attr-track={true}
        data-attr-analytics-trigger="product_selection"
        data-attr-analytics-value={logo.alt}
        onClick={onClick}
        sx={styles.cardButton({
          backgroundImage,
          backgroundColor,
          color,
        })}
        ref={ref}
        {...props}
      >
        <Box sx={styles.labelBox}>
          {description && (
            <Text variant="h5" sx={styles.description}>
              {description}
            </Text>
          )}

          <SvgOrImg
            type={logo?.type}
            src={logo.url}
            alt={logo.alt}
            sx={styles.logo}
          />

          {subText && <Text sx={styles.subText}>{subText}</Text>}

          {productLogo?.url && (
            <Box sx={styles.productLogo}>
              <SvgOrImg
                type={productLogo?.type}
                src={productLogo.url}
                alt={productLogo.alt}
                sx={
                  productLogo.alt === "Hyperlite"
                    ? styles.hyperliteLogo
                    : productLogo.alt === "SYNC"
                    ? styles.syncLogo
                    : styles.ultraLogo
                }
              />
            </Box>
          )}
        </Box>

        {!isSelected && (
          <Box
            sx={styles.selectLabel({
              boxColor,
              textColor,
              borderTop,
              selectLabelHeight,
              selectLabelFontSizeDesktop,
              selectLabelFontSizeMobile,
            })}
          >
            <SvgOrImg
              type={bauerLogo?.type}
              src={bauerLogo?.url ?? ""}
              alt={bauerLogo?.alt ?? ""}
              sx={bauerLogo?.url && styles.bauerLogo}
            />
            {selectLabel}
          </Box>
        )}
      </ThemeUiButton>
    </Box>
  );
}
